/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 24,
    height: 24,
    viewBox: '0 96 960 960',
    data: '<path pid="0" d="M560 776L360 576l200-200v400z"/>'
  }
})
